const RECOVERY_KEY_PREFIX = "veera:vite-preload-recovery";

function buildRecoveryKey(payload: unknown) {
  const raw =
    payload instanceof Error
      ? payload.message
      : typeof payload === "string"
        ? payload
        : JSON.stringify(payload ?? "unknown");

  return `${RECOVERY_KEY_PREFIX}:${raw}`;
}

type PreloadRecoveryOptions = {
  target?: Pick<Window, "addEventListener" | "removeEventListener"> | EventTarget;
  storage?: Pick<Storage, "getItem" | "setItem">;
  reload?: () => void;
};

export function registerVitePreloadRecovery(options: PreloadRecoveryOptions = {}) {
  if (typeof window === "undefined") {
    return () => undefined;
  }

  const target = options.target ?? window;
  const storage = options.storage ?? window.sessionStorage;
  const reload = options.reload ?? (() => window.location.reload());

  const handlePreloadError = (event: Event) => {
    const preloadEvent = event as Event & { payload?: unknown };
    const recoveryKey = buildRecoveryKey(preloadEvent.payload);

    if (storage.getItem(recoveryKey) === "1") {
      return;
    }

    storage.setItem(recoveryKey, "1");
    event.preventDefault();
    reload();
  };

  target.addEventListener("vite:preloadError", handlePreloadError);

  return () => {
    target.removeEventListener("vite:preloadError", handlePreloadError);
  };
}
